import { Component, Prop, h } from '@stencil/core';

import { setDealerListDisplay } from '../../../actions/actions.offer';
import { trackOfferCertificateHeader } from '../../../tracking/tracking.offer';
import { sleep } from '../../../utils/utils.js';
import KbycLogo from '../../ui-common/svg/KbycLogo';
import KbbicoBadgeLogo from '../../ui-common/svg/kbbico-logo/kbbico-kbb-badge-logo';
@Component({
  tag: 'offer-certificate-header',
  styleUrl: 'offer-certificate-header.css',
})
export class OfferCertificateHeader {
  @Prop() showKelleyBuysYourCar: boolean = false;
  @Prop() hideLinks: boolean = false;

  handlePrintClick = async (ev) => {
    ev.preventDefault();
    trackOfferCertificateHeader('print');
    setDealerListDisplay(true);
    await this.waitForGoogleMapRenderOnDAT();
    window.print();
  };

  async waitForGoogleMapRenderOnDAT() {
    await sleep(2000);
  }

  componentDidLoad() {
    window.addEventListener('beforeprint', (ev) => {
      ev.preventDefault();
      setDealerListDisplay(true);
    });
    window.addEventListener('afterprint', () => {
      setDealerListDisplay(false);
    });
  }

  getLogoSection() {
    const icoLogoClass = 'w-40 offer-certificate-header-logo-background offer-certificate-header-logo-background--visibility';
    const kbycLogoClass = 'w-42 mdLrg:w-[326px] offer-certificate-header-logo-background offer-certificate-header-logo-background--visibility';

    return (
      <div class="w-1/2 mt-2 mdLrg:mt-0">
        {this.showKelleyBuysYourCar ? (
          <div class={kbycLogoClass}>
            <KbycLogo />
          </div>
        ) : (
          <div class={icoLogoClass}>
            <KbbicoBadgeLogo alt="Kelley Blue Book" />
          </div>
        )}
      </div>
    );
  }

  render() {
    const headerContainerClass = {
      'flex flex-row mt-[16px]': true,
      'pb-8': !this.showKelleyBuysYourCar,
      'items-start': this.showKelleyBuysYourCar,
    };
    return (
      <div class={headerContainerClass}>
        {this.getLogoSection()}
        {!this.hideLinks && (
          <div class="w-1/2">
            <div class="mdLrg:mt-2.5 text-right">
              <ico-hyperlink noUnderline class="font-semibold text-xs" href="https://www.kbb.com/faq/ico/" target="_blank" onClick={() => trackOfferCertificateHeader('faq')}>
                FAQ
              </ico-hyperlink>{' '}
              |{' '}
              <ico-hyperlink noUnderline class="font-semibold text-xs" href="mailto:instantcashoffer@kbb.com" onClick={() => trackOfferCertificateHeader('email')}>
                Email
              </ico-hyperlink>{' '}
              |{' '}
              <ico-hyperlink noUnderline class="font-semibold text-xs" href="tel:1-866-559-5268" onClick={() => trackOfferCertificateHeader('call')}>
                Call
              </ico-hyperlink>{' '}
              |{' '}
              <ico-hyperlink noUnderline class="font-semibold text-xs" href="#" onClick={this.handlePrintClick}>
                Print
              </ico-hyperlink>
            </div>
          </div>
        )}
      </div>
    );
  }
}
